import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/components/ui/button';
import { ChannelIcon } from '@/components/ui/channel-icon';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { Typography } from '@/components/ui/typography';
import { useJobPostingContext } from '@/contexts/job-posting-context';
import { getChannelName } from '@/utils/channel-names';

export function ChannelsPopover() {
  const [open, setOpen] = useState(false);
  const { selectedChannelSlugs } = useJobPostingContext();

  if (selectedChannelSlugs.length === 1) {
    return (
      <ChannelIcon
        channelSlug={selectedChannelSlugs[0]}
        variant="large"
        className="!h-5"
      />
    );
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="link" className="h-fit hover:no-underline">
          <FormattedMessage
            defaultMessage="{count} Channels"
            values={{ count: selectedChannelSlugs.length }}
          />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="flex w-auto min-w-[160px] max-w-[240px] flex-col items-start justify-center"
      >
        {selectedChannelSlugs.map(channelSlug => (
          <div
            key={channelSlug}
            className="flex w-full items-center justify-between py-2"
          >
            <Typography variant="subtitle1">
              {getChannelName(channelSlug)}
            </Typography>
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
